import type { SiteOverdueSummary as SiteOverdueSummaryType } from "#/types/report";
import { formatCurrency } from "#/utils/formatCurrency";
import { useTranslation } from "react-i18next";
import ReportLink from "./ReportLink";

interface SiteOverdueSummaryProps {
  sites: SiteOverdueSummaryType[];
}

const MAX_SITES_TO_SHOW = 5;

/** Per-site counterpart of ProductOverdueSummary: how many of a section's items sit at each site. */
const SiteOverdueSummary = ({ sites }: SiteOverdueSummaryProps) => {
  const { t } = useTranslation();
  const displayedSites = sites.slice(0, MAX_SITES_TO_SHOW);

  return (
    <div className="flex flex-col gap-2">
      <span className="text-xs font-medium uppercase tracking-wider text-gray-500">
        {t("reports.inventoryScan.overdue.bySite")}
      </span>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3">
        {displayedSites.map((site) => (
          <div
            key={site.siteId ?? "unknown"}
            className="flex items-center justify-between rounded-md border border-gray-200 bg-gray-50 px-3 py-2"
          >
            <div className="flex flex-col">
              <span className="text-sm font-medium text-gray-800">
                {site.siteId ? (
                  <ReportLink href={`/sites/${site.siteId}`}>{site.siteName}</ReportLink>
                ) : (
                  site.siteName
                )}
              </span>
              <span className="text-xs text-gray-500">
                {site.itemCount} {t("reports.inventoryScan.overdue.items")}
              </span>
            </div>
            <span className="text-sm font-semibold text-gray-900">
              {formatCurrency(site.estimatedValue)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SiteOverdueSummary;
